import { FormControl, FormLabel, HStack, Icon } from '@chakra-ui/react';
import {
  MlsListingSubType,
  MlsListingType,
} from '@client/graphql/__generated__/types';
import {
  BathIcon,
  BedSingleIcon,
  Calendar1Icon,
  RulerIcon,
} from 'lucide-react';
import { CurrencyField } from '../../../Formik/CurrencyField';
import { NumberField } from '../../../Formik/NumberField';
import { SingleSelectField } from '../../../Formik/SingleSelectField';
import { TextField } from '../../../Formik/TextField';

export const PropertyDetailsStep = () => {
  return (
    <>
      <FormControl isRequired>
        <FormLabel>Target price</FormLabel>
        <CurrencyField bg="input.bg" name="targetPrice" />
      </FormControl>

      <FormControl isRequired>
        <FormLabel>Square Footage</FormLabel>
        <NumberField
          leftIcon={<Icon as={RulerIcon} color="whiteAlpha.600" />}
          name="squareFootage"
          size="md"
        />
      </FormControl>

      <FormControl isRequired>
        <FormLabel>Year built</FormLabel>
        <NumberField
          leftIcon={<Icon as={Calendar1Icon} color="whiteAlpha.600" />}
          name="yearBuilt"
          size="md"
        />
      </FormControl>

      <HStack align="flex-start" spacing={3}>
        <FormControl isRequired>
          <FormLabel>Bedrooms</FormLabel>
          <NumberField
            leftIcon={<Icon as={BedSingleIcon} color="whiteAlpha.600" />}
            name="bedrooms"
            size="md"
          />
        </FormControl>

        <FormControl isRequired>
          <FormLabel>Full bath(s)</FormLabel>
          <NumberField
            leftIcon={<Icon as={BathIcon} color="whiteAlpha.600" />}
            name="fullBaths"
            size="md"
          />
        </FormControl>

        <FormControl>
          <FormLabel>Half bath(s)</FormLabel>
          <NumberField
            leftIcon={<Icon as={BedSingleIcon} color="whiteAlpha.600" />}
            name="halfBaths"
            size="md"
          />
        </FormControl>
      </HStack>

      <FormControl isRequired>
        <FormLabel>Property type</FormLabel>
        <SingleSelectField
          maxMenuHeight={200}
          name="propertyType"
          options={Object.values(MlsListingType).map((type) => ({
            label: type,
            value: type,
          }))}
          size="sm"
        />
      </FormControl>

      <FormControl isRequired>
        <FormLabel>Property subtype</FormLabel>
        <SingleSelectField
          maxMenuHeight={200}
          name="propertySubtype"
          options={Object.values(MlsListingSubType).map((type) => ({
            label: type,
            value: type,
          }))}
          size="sm"
        />
      </FormControl>

      <FormControl>
        <FormLabel>Subdivision</FormLabel>
        <TextField name="subdivision" />
      </FormControl>

      <FormControl>
        <FormLabel>School district</FormLabel>
        <TextField name="schoolDistrict" />
      </FormControl>
    </>
  );
};
